import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../Header/Header';

const Blogs = () => {
    return (
        <div>
            <Header></Header>
            <Container>
            <h1>I m working on blogs. They are coming soon</h1>
        </Container>
        </div>
    );
};

export default Blogs;